<template>
  <div>
    <v-overlay :value="loading" class="align-center justify-center">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="error.show">
      <p class="py-0 my-0 font-weight-black">{{ error.title }}</p>
      {{ error.message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error.show = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <v-toolbar flat style="background-color: #f3f3f3">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="green" dark class="mb-2 ml-2" v-bind="attrs" v-on="on" @click="carregarTabelaDeValores()">
            <v-icon small> mdi-list-box-outline </v-icon>
          </v-btn>
        </template>
        <span>Tabela de valores</span>
      </v-tooltip>

    </v-toolbar>

    <v-alert type="info" border="left" colored-border elevation="2" class="ma-3">
      <div class="text-h6 mb-2">
        Informações sobre o faturamento
      </div>
      <ul class="ml-4">
        <li>As faturas são geradas automaticamente todo <strong>dia 01</strong> de cada mês</li>
        <li>Data de vencimento: <strong>dia 10</strong> de cada mês</li>
        <li>As faturas são enviadas para os contatos informados no credenciamento</li>
        <li class="error--text">Pagamento em atraso pode acarretar juros e bloqueio das lojas dos seus clientes</li>
      </ul>
    </v-alert>

    <v-container class="ma-0" fluid>
      <v-data-table :headers="headers" :items="faturas" sort-by="nome" class="elevation-1" :loading="loadingLista"
        loading-text="Carregando..." :search="pesquisar" @dblclick:row="($event, { item }) => pagar(item.invoiceUrl)"
        :footer-props="{
          'items-per-page-options': [12, 24, 36, 48, 60, 100, -1],
        }" :items-per-page="12" locale="pt" item-key="data">

        <template v-slot:top>
          <v-toolbar flat v-if="!loadingLista">
            <v-text-field v-model="pesquisar" append-icon="mdi-magnify" label="Pesquisar" single-line
              hide-details></v-text-field>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="grey" dark class="mb-2 ml-2" v-bind="attrs" v-on="on" @click="atualizar()">
                  <v-icon small> mdi-refresh </v-icon>
                </v-btn>
              </template>
              <span>Atualizar lista</span>
            </v-tooltip>
          </v-toolbar>
        </template>

        <template v-slot:item.dateCreated="{ item }">
          <span>{{
            new Date(`${item.dueDate}T00:00:00`).toLocaleDateString('pt-BR', {
              timeZone: 'UTC', month:
                'long'
            }).replace(/^./, str => str.toUpperCase())
          }}</span>
        </template>

        <template v-slot:item.value="{ item }">
          <span>{{
            item.value.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }}</span>
        </template>

        <template v-slot:item.status="{ item }">
          <span>{{ status[item.status] }}
            {{
              item.paymentDate
              ? "em " +
              new Date(`${item.paymentDate}T00:00:00`).toLocaleString(
                "default",
                { day: "2-digit", month: "2-digit" }
              )
              : ""
            }}</span>
        </template>

        <template v-slot:item.opcoes="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" :color="cor[status[item.status]]" v-bind="attrs" v-on="on"
                @click="pagar(item.invoiceUrl)">
                mdi-credit-card
              </v-icon>
            </template>
            <span>Fatura</span>
          </v-tooltip>
        </template>

        <template v-slot:item.dueDate="{ item }">
          <span>{{
            new Date(`${item.dueDate}T00:00:00`).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
          }}</span>
        </template>
      </v-data-table>
    </v-container>

    <template>
      <v-row justify="center">
        <v-dialog v-model="modal.valores" max-width="600px">
          <v-card>
            <v-card-title class="success white--text">
              <v-icon left color="white">mdi-list-box-outline</v-icon>
              <span class="headline">Tabela de valores</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="modal.valores = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text style="max-height: 70vh; overflow-y: auto;">
              <v-container>
                <p>Todos os outros módulos não listados podem ser utilizados de forma gratuita e você pode cobrar o valor
                  que preferir por cada um deles.</p>

                <h3 class="mt-3 blue--text">Valores</h3>
                <hr class="mb-3 mt-2" />

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="this.valorMinimoRevenda" label="Valor mínimo"
                      :hint="'Valor mínimo cobrado mensalmente (' + this.qtdMinimoLojasRevenda + ' lojas)'" type="number"
                      prefix="R$" filled readonly persistent-hint></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="this.valorRevenda" label="Fatura mínima"
                      :hint="'Valor mínimo de fatura (mesmo utilizando créditos)'" type="number" prefix="R$" filled
                      readonly persistent-hint></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="this.valorRevenda" label="Loja"
                      hint="Valor cobrado mês/por loja (exceto demonstração)" type="number" prefix="R$" filled readonly
                      persistent-hint></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="this.valorGamaZapCampanhas" label="WhatsApp - Campanhas" hint="mês/por loja"
                      type="number" prefix="R$" filled readonly persistent-hint></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="this.valorRobo" label="WhatsApp - Robô de atendimento" hint="mês/por loja"
                      type="number" prefix="R$" filled readonly persistent-hint></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="this.valorNfce" label="Emissão de NFC-e" hint="por nota" type="number"
                      prefix="R$" filled readonly persistent-hint></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="this.valorNfe" label="Emissão de NF-e" hint="por nota" type="number"
                      prefix="R$" filled readonly persistent-hint></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="this.valorDfe" label="Recebimento de NF-e (DF-e)" hint="por nota" type="number"
                      prefix="R$" filled readonly persistent-hint></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="this.valorGtef" label="G-TEF" hint="por pos (máquininha) ativo" type="number"
                      prefix="R$" filled readonly persistent-hint></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="this.valorGpos" label="G-POS" hint="por loja ativa" type="number" prefix="R$"
                      filled readonly persistent-hint></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="this.valorSuporte" label="Suporte ao cliente" hint="por loja ativa"
                      type="number" prefix="R$" filled readonly persistent-hint></v-text-field>
                  </v-col>

                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="modal.valores = false">
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </div>
</template>

<script>
import {
  fetchApiClientes,
  asaasListarFaturas,
  responsavelGeralDados,
  validarRevenda,
  usarCreditos,
  asaasCriarFatura,
} from "../../services/api";
import { verificarSessao, getMes } from "../../utils/utils";

export default {
  name: "Faturas",
  data() {
    return {
      loading: false,
      loadingLista: true,
      error: {
        show: false,
        message: "",
        title: "",
      },
      headers: [
        { text: "Mês", value: "dateCreated" },
        { text: "Vencimento", value: "dueDate" },
        { text: "Descrição", value: "description" },
        { text: "Valor", value: "value" },
        { text: "Status", value: "status" },
        { text: "Opções", value: "opcoes", sortable: false },
      ],
      faturas: [],
      pesquisar: "",
      status: {
        RECEIVED: "Pago",
        CONFIRMED: "Pago",
        RECEIVED_IN_CASH: "Pago",
        AWAITING_RISK_ANALYSIS: "Pendente",
        PENDING: "Pendente",
        OVERDUE: "Atrasado",
        REFUND_REQUESTED: "Estornado",
        REFUND: "Estornado",
        REFUNDED: "Estornado",
      },
      cor: {
        Pago: "green",
        Pendente: "orange",
        Atrasado: "red",
        Estornado: "red",
      },
      token: localStorage.getItem("token"),
      asaas_id_revenda: this.$route.params.asaas_id_revenda,
      modal: {
        valores: false,
      },
      inputs: {},
    };
  },
  async created() {
    window.addEventListener("offline", () => (this.loading = true));
    window.addEventListener("online", () => (this.loading = false));
    /**
     *
     */
    verificarSessao(this.gerarCobranca);
    setTimeout(verificarSessao, 1 * 60000);
  },
  methods: {
    setLoading(loading) {
      this.loading = loading;
      this.$root.$emit('global-loading', loading);
    },
    setError(error) {
      this.error = {
        show: true,
        title: "Ops, falhou!",
        message: error ? error : "Falha não identificada, tente novamente.",
      };
    },
    async atualizar() {
      this.loadingLista = true;
      return asaasListarFaturas(this.token, this.asaas_id_revenda)
        .then((response) => {
          this.loadingLista = false;
          this.faturas = response?.data?.faturas?.data;
        })
        .catch((error) => {
          this.loadingLista = false;
          this.setError(error);
        });
    },
    /**
     *
     */
    async gerarCobranca() {
      try {
        const faturas = await asaasListarFaturas(this.token, this.asaas_id_revenda);
        const ultimaFatura = faturas?.data?.faturas?.data?.filter(m => !m.externalReference || m.externalReference === "fatura_mensal_revenda").shift();
        if (ultimaFatura) {
          const mesAtual = new Date().toLocaleString("default", {
            month: "2-digit",
            year: "2-digit",
          });
          const mesUltimaFatura = new Date(
            `${ultimaFatura.dueDate}T00:00:00`
          ).toLocaleString("default", { month: "2-digit", year: "2-digit" });
          if (mesUltimaFatura === mesAtual) {
            throw new Error("A última fatura já foi gerada pra revenda.");
          }
        }

        let cobranca = 0;
        let total = {
          lojas: {
            qtd: 0,
            valor: 0,
          },
          lojas_demos: {
            qtd: 0,
            valor: 0,
          },
          lojas_bloqueadas: {
            qtd: 0,
            valor: 0,
          },
          nfces: {
            qtd: 0,
            valor: 0,
          },
          nfes: {
            qtd: 0,
            valor: 0,
          },
          dfes: {
            qtd: 0,
            valor: 0,
          },
          gamazaps: {
            qtd: 0,
            valor: 0,
          },
          gamazaps_campanhas: {
            qtd: 0,
            valor: 0,
          },
          robos: {
            qtd: 0,
            valor: 0,
          },
          gtefs: {
            qtd: 0,
            valor: 0,
          },
          gposs: {
            qtd: 0,
            valor: 0,
          },
          suporte: {
            qtd: 0,
            valor: 0,
          },
        };

        const clientes = await fetchApiClientes(this.token);
        clientes?.data?.clientes?.ativos.map((cliente) => {
          // Não cobrar
          if (cliente.nome === "demonstracao") {
            total.lojas_demos.qtd++;
            return;
          }

          // Não cobrar
          if (cliente.block === "🔴") {
            total.lojas_bloqueadas.qtd++;
            return;
          }

          total.lojas.qtd++;
          total.lojas.valor += this.valorRevenda;
          cobranca += this.valorRevenda;

          if (!cliente.analytics) {
            return;
          }

          const nfces = parseInt(cliente?.analytics?.fiscal60dias ?? 0);
          if (nfces > 0) {
            total.nfces.qtd += nfces;
            total.nfces.valor += nfces * this.valorNfce;
            cobranca += nfces * this.valorNfce;
          }

          const nfes = parseInt(cliente?.analytics?.nfes60dias ?? 0);
          if (nfes > 0) {
            total.nfes.qtd += nfes;
            total.nfes.valor += nfes * this.valorNfe;
            cobranca += nfes * this.valorNfe;
          }

          const dfes = parseInt(cliente?.analytics?.dfes60dias ?? 0);
          if (dfes > 0) {
            total.dfes.qtd += dfes;
            total.dfes.valor += dfes * this.valorDfe;
            cobranca += dfes * this.valorDfe;
          }

          if (cliente.analytics[`modulos_mes${getMes(-1)}`]) {
            const gamazaps = parseInt(
              cliente.analytics[`modulos_mes${getMes(-1)}`].gamazap ?? 0
            );
            if (gamazaps > 0) {
              total.gamazaps.qtd += gamazaps;
              total.gamazaps.valor += gamazaps * this.valorGamaZap;
              cobranca += gamazaps * this.valorGamaZap;
            }

            const gamazaps_campanhas = parseInt(
              cliente.analytics[`modulos_mes${getMes(-1)}`].gamazap_campanhas ??
              0
            );
            if (gamazaps_campanhas > 0) {
              total.gamazaps_campanhas.qtd += gamazaps_campanhas;
              total.gamazaps_campanhas.valor += gamazaps_campanhas * this.valorGamaZapCampanhas;
              cobranca += gamazaps_campanhas * this.valorGamaZapCampanhas;
            }

            const robos = parseInt(
              cliente.analytics[`modulos_mes${getMes(-1)}`].robo ?? 0
            );
            if (robos > 0) {
              total.robos.qtd += robos;
              total.robos.valor += robos * this.valorRobo;
              cobranca += robos * this.valorRobo;
            }

            const gtefs = parseInt(
              cliente.analytics[`modulos_mes${getMes(-1)}`].gtef ??
              0
            );
            if (gtefs > 0) {
              total.gtefs.qtd += gtefs;
              total.gtefs.valor += gtefs * this.valorGtef;
              cobranca += gtefs * this.valorGtef;
            }

            const gposs = parseInt(
              cliente.analytics[`modulos_mes${getMes(-1)}`].gpos ??
              0
            );
            if (gposs > 0) {
              total.gposs.qtd += gposs;
              total.gposs.valor += gposs * this.valorGpos;
              cobranca += gposs * this.valorGpos;
            }

            const suporte = parseInt(
              cliente.analytics[`modulos_mes${getMes(-1)}`].suporte_dedicado ??
              0
            );
            if (suporte > 0) {
              total.suporte.qtd += suporte;
              total.suporte.valor += suporte * this.valorSuporte;
              cobranca += suporte * this.valorSuporte;
            }
          }
        });

        if (total.lojas.qtd < this.qtdMinimoLojasRevenda) {
          cobranca -= total.lojas.valor;
          cobranca += this.valorMinimoRevenda;
          total.lojas.valor = this.valorMinimoRevenda;
        }

        let descricao = "";
        if (this.isDesenvolvimento) {
          descricao += `(DEV) `;
          cobranca = 100;
        }

        descricao += `${total.lojas.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ` + (total.lojas.qtd < this.qtdMinimoLojasRevenda ? `${total.lojas.qtd}/${this.qtdMinimoLojasRevenda} lojas mínimas \n ` : `${total.lojas.qtd} lojas \n `);

        descricao += `${total.lojas_demos.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.lojas_demos.qtd} lojas de demonstração (não cobrado) \n `;

        descricao += `${total.lojas_bloqueadas.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.lojas_bloqueadas.qtd} lojas bloqueadas (não cobrado) \n `;

        descricao += `${total.nfces.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.nfces.qtd} NFC-e emitidas \n `;

        descricao += `${total.nfes.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.nfes.qtd} NF-e emitidas \n `;

        descricao += `${total.dfes.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.dfes.qtd} NF-e (DF-e) recebidas \n `;

        descricao += `${total.gamazaps.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.gamazaps.qtd} WhatsApp Conectados \n `;

        descricao += `${total.gamazaps_campanhas.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.gamazaps_campanhas.qtd} WhatsApp Marketing \n `;

        descricao += `${total.robos.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.robos.qtd} Robôs de atendimento \n `;

        descricao += `${total.gtefs.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.gtefs.qtd} [G-TEF] POS ativos \n `;

        descricao += `${total.gposs.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.gposs.qtd} G-POS \n `;

        descricao += `${total.suporte.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - ${total.suporte.qtd} Suporte ao cliente \n `;

        let desconto = null;

        const { creditos } = await this.buscarRevenda();
        if (creditos > 0) {
          let creditosUtilizados = 0;

          if (creditos >= cobranca) {
            creditosUtilizados = (cobranca - this.valorRevenda);
            descricao += `\n -${creditosUtilizados.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - crédito utilizado\n `;
            desconto = {
              type: "FIXED",
              value: creditosUtilizados,
            };
          } else {
            creditosUtilizados = creditos;
            descricao += `\n -${creditos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} - crédito utilizado\n `;
            desconto = {
              type: "FIXED",
              value: creditos,
            };
          }

          const usar = await usarCreditos(this.dominio, creditosUtilizados);
          if (!usar) {
            throw new Error("Não foi possível utilizar os créditos da revenda.");
          }
        }

        const criarFatura = await asaasCriarFatura(this.token, {
          billingType: "PIX",
          interest: { value: 1 },
          fine: { value: 2, type: "PERCENTAGE" },
          discount: desconto,
          customer: this.asaas_id_revenda,
          dueDate: `${new Date().getFullYear()}-${getMes()}-10`,
          value: cobranca,
          description: descricao,
          externalReference: "fatura_mensal_revenda",
          split: [
            {
              walletId: (this.isDesenvolvimento ? "7171bb1c-f2d2-4729-bf08-ec90431ccaf5" : "ec7ac8c2-9e1f-44c9-9d6e-bae9088523ea"),
              percentualValue: 25,
            },
          ],
          callback: {
            successUrl: `https://painel.gamadelivery.app/redirecionar.php?url=${window.location.href}`,
            autoRedirect: true,
          },
        });
        if (!criarFatura) {
          throw new Error(
            "Não foi possível gerar a fatura do mês pra revenda."
          );
        }
      } catch (err) {
        console.error(err.message);
      } finally {
        await this.atualizar();
      }
    },
    /**
     *
     */
    async buscarRevenda() {
      const { data: revenda } = await responsavelGeralDados(this.token);
      const { data: dados } = await validarRevenda(this.dominio, revenda.responsavel?.nome_empresa);
      return { ...dados.data, api_key: revenda.responsavel?.api_key };
    },
    /**
     *
     */
    carregarTabelaDeValores() {
      this.modal.valores = true;
    },
    /**
     *
     */
    pagar(url) {
      window.location.href = url;
    },
  },
};
</script>

<style>
body {
  margin: 15px !important;
}
</style>
